import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private isRefreshing = false;

    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isAuthEndpoint(request.url)) {
            return next.handle(request);
        }

        const accessToken = this.authService.getAccessToken();

        if (accessToken) {
            request = this.addAuthHeader(request, accessToken);
        } else {
            // Add subscription key even without auth token
            request = this.addSubscriptionKey(request);
        }

        return next.handle(request).pipe(
            catchError(error => {
                if (error.status === 401 && !this.isRefreshing) {
                    return this.handle401Error(request, next);
                }
                return throwError(error)
            })
        )
    }

    private addAuthHeader(request: HttpRequest<any>, accessToken: string): HttpRequest<any> {
        return request.clone({
            headers: request.headers
                .set('Authorization', `Bearer ${accessToken}`)
                .set('Ocp-Apim-Subscription-Key', environment.subscriptionKey)
        });
    }

    private addSubscriptionKey(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            headers: request.headers.set('Ocp-Apim-Subscription-Key', environment.subscriptionKey)
        });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.isRefreshing = true;

        return this.authService.refreshTokens().pipe(
            switchMap(() => {
                this.isRefreshing = false;
                const newToken = this.authService.getAccessToken();
                return next.handle(this.addAuthHeader(request, newToken));
            }),
            catchError((error) => {
                this.isRefreshing = false;
                this.authService.logout();
                return throwError(error);
            })
        );
    }

    private isAuthEndpoint(url: string): boolean {
        return url.includes('/auth/');
    }
}